var _toConsumableArray = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _possibleConstructorReturn = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = function (t) {
  var i = {};

  function e(n) {
    if (i[n]) return i[n].exports;
    var o = i[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
  }

  return e.m = t, e.c = i, e.d = function (t, i, n) {
    e.o(t, i) || Object.defineProperty(t, i, {
      enumerable: !0,
      get: n
    });
  }, e.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, e.t = function (t, i) {
    if (1 & i && (t = e(t)), 8 & i) return t;
    if (4 & i && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (e.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & i && "string" != typeof t) for (var o in t) {
      e.d(n, o, function (i) {
        return t[i];
      }.bind(null, o));
    }
    return n;
  }, e.n = function (t) {
    var i = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return e.d(i, "a", i), i;
  }, e.o = function (t, i) {
    return Object.prototype.hasOwnProperty.call(t, i);
  }, e.p = "", e(e.s = 2);
}([function (t, i) {
  t.exports = require("react");
}, function (t, i, e) {}, function (t, i, e) {
  "use strict";

  e.r(i), e.d(i, "store", function () {
    return m;
  });
  var n = e(0),
      o = e.n(n);
  var s = !0,
      a = 768,
      r = 325,
      c = "notification__item";
  var l, h, u, d;
  !function (t) {
    t.BOTTOM_LEFT = "bottom-left", t.BOTTOM_RIGHT = "bottom-right", t.BOTTOM_CENTER = "bottom-center", t.TOP_LEFT = "top-left", t.TOP_RIGHT = "top-right", t.TOP_CENTER = "top-center", t.CENTER = "center", t.TOP_FULL = "top-full", t.BOTTOM_FULL = "bottom-full";
  }(l || (l = {})), function (t) {
    t.TOP = "top", t.BOTTOM = "bottom";
  }(h || (h = {})), function (t) {
    t.SUCCESS = "success", t.DANGER = "danger", t.INFO = "info", t.DEFAULT = "default", t.WARNING = "warning";
  }(u || (u = {})), function (t) {
    t.TIMEOUT = "timeout", t.CLICK = "click", t.TOUCH = "touch", t.MANUAL = "manual";
  }(d || (d = {}));
  var m = new ( /*#__PURE__*/function () {
    function _class() {
      var _this = this;

      _classCallCheck(this, _class);

      this.incrementCounter = function () {
        return _this.counter += 1;
      }, this.getCounter = function () {
        return _this.counter;
      }, this.counter = 0, this.add = null;
    }

    _createClass(_class, [{
      key: "addNotification",
      value: function addNotification(t) {
        this.incrementCounter();

        var i = function (t, i, e) {
          var n = t,
              o = n.id,
              s = n.type,
              a = n.insert,
              r = n.content,
              c = n.container,
              l = n.animationIn,
              h = n.animationOut,
              d = n.slidingEnter,
              p = n.slidingExit,
              E = n.touchRevert,
              T = n.touchSlidingExit,
              N = n.dismiss,
              O = n.width,
              g = n.onRemoval;
          n.id = o || m.getCounter().toString(), n.type = r ? null : s.toLowerCase(), i && !r && (n.userDefinedTypes = function (t, i) {
            var e = t.content,
                n = t.type;
            if (e) return;
            if (n === u.SUCCESS || n === u.DANGER || n === u.INFO || n === u.DEFAULT || n === u.WARNING || !i) return;
            return i;
          }(n, i));
          n.width = f(O) ? e : O, n.container = c.toLowerCase(), n.insert = (a || "top").toLowerCase(), n.dismiss = function (t) {
            var i = t,
                e = {
              duration: 0,
              click: !0,
              touch: !0,
              onScreen: !1,
              pauseOnHover: !1,
              waitForAnimation: !1,
              showIcon: !1
            };
            if (!i) return e;
            return Object.keys(e).forEach(function (t) {
              f(i[t]) && (i[t] = e[t]);
            }), i;
          }(N), n.animationIn = l || [], n.animationOut = h || [], n.onRemoval = g || function () {};

          var b = function b(t, i, e) {
            return {
              duration: t,
              timingFunction: i,
              delay: e
            };
          };

          n.slidingEnter = v(d, b(600, "linear", 0)), n.slidingExit = v(p, b(600, "linear", 0)), n.touchRevert = v(E, b(600, "linear", 0));

          var S = T || {},
              y = S.swipe || {},
              _ = S.fade || {};

          return n.touchSlidingExit = S, n.touchSlidingExit.swipe = v(y, b(600, "linear", 0)), n.touchSlidingExit.fade = v(_, b(300, "linear", 0)), n;
        }(t, this.types, this.defaultNotificationWidth);

        return this.add(i);
      }
    }, {
      key: "register",
      value: function register(t) {
        var i = t.addNotification,
            e = t.removeNotification,
            n = t.removeAllNotifications,
            o = t.types,
            s = t.defaultNotificationWidth;
        this.add = i, this.removeNotification = e, this.removeAllNotifications = n, this.defaultNotificationWidth = s, this.types = o;
      }
    }]);

    return _class;
  }())();

  var f = function f(t) {
    return null == t;
  };

  function p(t) {
    return t === l.BOTTOM_FULL || t === l.BOTTOM_LEFT || t === l.BOTTOM_RIGHT || t === l.BOTTOM_CENTER;
  }

  function E(t) {
    return t === l.TOP_FULL || t === l.TOP_LEFT || t === l.TOP_RIGHT || t === l.TOP_CENTER;
  }

  function T(t) {
    var i = t.type,
        e = t.content,
        n = t.userDefinedTypes,
        o = [c];
    if (e) return o;
    if (f(n)) return function (t) {
      switch (t) {
        case u.DEFAULT:
          return [c, "notification__item--default"];

        case u.SUCCESS:
          return [c, "notification__item--success"];

        case u.DANGER:
          return [c, "notification__item--danger"];

        case u.WARNING:
          return [c, "notification__item--warning"];

        case u.INFO:
          return [c, "notification__item--info"];

        default:
          return [c];
      }
    }(i);
    var s = n.find(function (t) {
      return t.name === i;
    });
    return o.concat(s.htmlClasses);
  }

  function N(_ref, n) {
    var t = _ref.duration,
        i = _ref.timingFunction,
        e = _ref.delay;
    return "".concat(t, "ms ").concat(n, " ").concat(i, " ").concat(e, "ms");
  }

  function v(t, _ref2) {
    var i = _ref2.duration,
        e = _ref2.timingFunction,
        n = _ref2.delay;
    var o = t || {};
    return f(o.duration) && (o.duration = i), f(o.timingFunction) && (o.timingFunction = e), f(o.delay) && (o.delay = n), o;
  }

  var O = /*#__PURE__*/function () {
    function O(t, i) {
      _classCallCheck(this, O);

      this.callback = t, this.remaining = i, this.resume();
    }

    _createClass(O, [{
      key: "pause",
      value: function pause() {
        clearTimeout(this.timerId), this.remaining -= Date.now() - this.start;
      }
    }, {
      key: "resume",
      value: function resume() {
        this.start = Date.now(), clearTimeout(this.timerId), this.timerId = setTimeout(this.callback, this.remaining);
      }
    }, {
      key: "clear",
      value: function clear() {
        clearTimeout(this.timerId);
      }
    }]);

    return O;
  }();

  var g = /*#__PURE__*/function (_o$a$Component) {
    _inherits(g, _o$a$Component);

    function g(t) {
      var _this2;

      _classCallCheck(this, g);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, t)), _this2.onClick = function () {
        var t = _this2.props.notification.dismiss;
        (t.click || t.showIcon) && _this2.removeNotification(d.CLICK);
      }, _this2.onTouchStart = function (t) {
        var i = t.touches[0].pageX;

        _this2.setState(function (_ref3) {
          var t = _ref3.parentStyle;
          return {
            startX: i,
            currentX: i,
            parentStyle: Object.assign(Object.assign({}, t), {
              position: "relative"
            })
          };
        });
      }, _this2.onTouchMove = function (t) {
        var i = t.touches[0].pageX,
            e = _this2.state.startX,
            _this2$props = _this2.props,
            n = _this2$props.toggleRemoval,
            _this2$props$notifica = _this2$props.notification,
            o = _this2$props$notifica.id,
            s = _this2$props$notifica.onRemoval,
            a = _this2$props$notifica.slidingExit,
            _this2$props$notifica2 = _this2$props$notifica.touchSlidingExit,
            r = _this2$props$notifica2.swipe,
            c = _this2$props$notifica2.fade,
            l = i - e,
            h = _this2.rootElementRef.current.offsetWidth,
            u = window.innerWidth + h,
            m = (i - e >= 0 ? u : -u) + "px";

        if (function (t, i) {
          return Math.abs(t) >= .4 * i;
        }(l, h)) {
          var _t = N(r, "left"),
              _i = N(c, "opacity"),
              _e = function _e() {
            n(o, function () {
              return s(o, d.TOUCH);
            });
          };

          return _this2.setState(function (_ref4) {
            var n = _ref4.parentStyle;
            return {
              touchEnabled: !1,
              parentStyle: Object.assign(Object.assign({}, n), {
                left: m,
                opacity: 0,
                transition: "".concat(_t, ", ").concat(_i)
              }),
              onTransitionEnd: function onTransitionEnd() {
                _this2.setState(function (_ref5) {
                  var t = _ref5.parentStyle;
                  return {
                    parentStyle: Object.assign(Object.assign({}, t), {
                      height: "0px",
                      overflow: "hidden",
                      transition: N(a, "height")
                    }),
                    onTransitionEnd: _e
                  };
                });
              }
            };
          });
        }

        return _this2.setState(function (_ref6) {
          var t = _ref6.parentStyle;
          return {
            currentX: i,
            parentStyle: Object.assign(Object.assign({}, t), {
              left: 0 + l + "px"
            })
          };
        });
      }, _this2.onTouchEnd = function () {
        var t = _this2.props.notification.touchRevert;

        _this2.setState(function (_ref7) {
          var i = _ref7.parentStyle;
          return {
            parentStyle: Object.assign(Object.assign({}, i), {
              left: 0,
              transition: N(t, "left")
            })
          };
        });
      }, _this2.onMouseEnter = function () {
        _this2.timer ? _this2.timer.pause() : _this2.setState({
          animationPlayState: "paused"
        });
      }, _this2.onMouseLeave = function () {
        _this2.timer ? _this2.timer.resume() : _this2.setState({
          animationPlayState: "running"
        });
      }, _this2.rootElementRef = o.a.createRef();
      var i = t.defaultNotificationWidth,
          e = t.notification,
          n = t.isMobile,
          s = e.width,
          a = e.container;
      _this2.state = {
        parentStyle: {
          height: "0px",
          overflow: "hidden",
          width: (s || i) + "px"
        },
        htmlClassList: T(e),
        animationPlayState: "running",
        touchEnabled: !0
      };
      var r = -1 !== [l.TOP_FULL, l.BOTTOM_FULL, l.TOP_CENTER, l.BOTTOM_CENTER, l.CENTER].indexOf(a);
      (n || r) && (_this2.state.parentStyle.width = "100%");
      return _this2;
    }

    _createClass(g, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.timer && this.timer.clear();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this3 = this;

        var _this$props = this.props,
            t = _this$props.notification,
            i = _this$props.notificationsCount,
            _t$dismiss = t.dismiss,
            e = _t$dismiss.duration,
            n = _t$dismiss.onScreen,
            o = function (t, i) {
          return !(i <= 1) && i > 1 && (t.insert === h.TOP && E(t.container) || t.insert === h.BOTTOM && p(t.container) || t.container === l.CENTER);
        }(t, i),
            s = this.rootElementRef.current.scrollHeight,
            a = function a() {
          if (!e || n) return;
          _this3.timer = new O(function () {
            return _this3.removeNotification(d.TIMEOUT);
          }, e);
        };

        this.setState(function (_ref8) {
          var i = _ref8.parentStyle.width;
          return {
            parentStyle: {
              width: i,
              height: s + "px",
              transition: o ? N(t.slidingEnter, "height") : "10ms height"
            },
            onTransitionEnd: a
          };
        }, function () {
          requestAnimationFrame(function () {
            _this3.setState(function (i) {
              return {
                htmlClassList: [].concat(_toConsumableArray(t.animationIn), _toConsumableArray(i.htmlClassList))
              };
            });
          });
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(_ref9) {
        var t = _ref9.hasBeenRemoved;
        this.props.hasBeenRemoved && !t && this.removeNotification(d.MANUAL);
      }
    }, {
      key: "removeNotification",
      value: function removeNotification(t) {
        var _this4 = this;

        var _this$props2 = this.props,
            i = _this$props2.notification,
            e = _this$props2.toggleRemoval,
            n = i.id,
            o = i.onRemoval,
            s = i.dismiss.waitForAnimation,
            a = [].concat(_toConsumableArray(i.animationOut), _toConsumableArray(T(i))),
            r = function r() {
          return e(n, function () {
            return o(n, t);
          });
        },
            c = {
          height: "0px",
          overflow: "hidden",
          transition: N(i.slidingExit, "height")
        };

        return s ? this.setState(function (_ref10) {
          var t = _ref10.parentStyle.width;
          return {
            htmlClassList: a,
            onAnimationEnd: function onAnimationEnd() {
              _this4.setState({
                parentStyle: Object.assign({
                  width: t
                }, c),
                onTransitionEnd: r
              });
            }
          };
        }) : this.setState(function (_ref11) {
          var t = _ref11.parentStyle.width;
          return {
            parentStyle: Object.assign({
              width: t
            }, c),
            onTransitionEnd: r,
            htmlClassList: a
          };
        });
      }
    }, {
      key: "renderTimer",
      value: function renderTimer() {
        var _this5 = this;

        var t = this.props.notification.dismiss,
            i = t.duration,
            e = t.onScreen,
            n = this.state.animationPlayState;
        if (!i || !e) return;
        var s = {
          animationName: "timer",
          animationDuration: i + "ms",
          animationTimingFunction: "linear",
          animationFillMode: "forwards",
          animationDelay: "0",
          animationPlayState: n
        };
        return o.a.createElement("div", {
          className: "notification__timer"
        }, o.a.createElement("div", {
          className: "notification__timer-filler",
          onAnimationEnd: function onAnimationEnd() {
            return _this5.removeNotification(d.TIMEOUT);
          },
          style: s
        }));
      }
    }, {
      key: "renderCustomContent",
      value: function renderCustomContent() {
        var t = this.state.htmlClassList,
            _this$props$notificat = this.props.notification,
            i = _this$props$notificat.id,
            e = _this$props$notificat.content,
            _this$props$notificat2 = _this$props$notificat.dismiss,
            n = _this$props$notificat2.duration,
            s = _this$props$notificat2.pauseOnHover,
            a = n > 0 && s;
        return o.a.createElement("div", {
          className: "" + _toConsumableArray(t).join(" "),
          onMouseEnter: a ? this.onMouseEnter : null,
          onMouseLeave: a ? this.onMouseLeave : null
        }, o.a.isValidElement(e) ? e : o.a.createElement(e, Object.assign({}, {
          id: i
        })));
      }
    }, {
      key: "renderNotification",
      value: function renderNotification() {
        var _this$props$notificat3 = this.props.notification,
            t = _this$props$notificat3.title,
            i = _this$props$notificat3.message,
            _this$props$notificat4 = _this$props$notificat3.dismiss,
            e = _this$props$notificat4.showIcon,
            n = _this$props$notificat4.duration,
            s = _this$props$notificat4.pauseOnHover,
            a = this.state.htmlClassList,
            r = n > 0 && s;
        return o.a.createElement("div", {
          className: "" + _toConsumableArray(a).join(" "),
          onMouseEnter: r ? this.onMouseEnter : null,
          onMouseLeave: r ? this.onMouseLeave : null
        }, o.a.createElement("div", {
          className: "notification__content"
        }, e && o.a.createElement("div", {
          className: "notification__close",
          onClick: this.onClick
        }), t && o.a.createElement("div", {
          className: "notification__title"
        }, t), o.a.createElement("div", {
          className: "notification__message"
        }, i), this.renderTimer()));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props$notificat5 = this.props.notification,
            t = _this$props$notificat5.content,
            i = _this$props$notificat5.dismiss.click,
            _this$state = this.state,
            e = _this$state.parentStyle,
            n = _this$state.onAnimationEnd,
            s = _this$state.onTransitionEnd,
            a = _this$state.touchEnabled;
        return o.a.createElement("div", {
          ref: this.rootElementRef,
          onClick: i ? this.onClick : null,
          className: "notification",
          style: e,
          onAnimationEnd: n,
          onTransitionEnd: s,
          onTouchStart: a ? this.onTouchStart : null,
          onTouchMove: a ? this.onTouchMove : null,
          onTouchEnd: a ? this.onTouchEnd : null
        }, t ? this.renderCustomContent() : this.renderNotification());
      }
    }]);

    return g;
  }(o.a.Component);

  var b = g;
  e(1);

  var S = /*#__PURE__*/function (_o$a$Component2) {
    _inherits(S, _o$a$Component2);

    function S(t) {
      var _this6;

      _classCallCheck(this, S);

      _this6 = _possibleConstructorReturn(this, _getPrototypeOf(S).call(this, t)), _this6.handleResize = function () {
        _this6.setState({
          windowWidth: window.innerWidth
        });
      }, _this6.add = function (t) {
        return _this6.setState(function (_ref12) {
          var i = _ref12.notifications;
          return {
            notifications: "top" === t.insert ? [t].concat(_toConsumableArray(i)) : [].concat(_toConsumableArray(i), [t])
          };
        }), t.id;
      }, _this6.remove = function (t) {
        _this6.setState(function (_ref13) {
          var i = _ref13.notifications;
          return {
            notifications: i.map(function (i) {
              return i.id === t && (i.hasBeenRemoved = !0), i;
            })
          };
        });
      }, _this6.removeAllNotifications = function () {
        _this6.setState({
          notifications: _this6.state.notifications.map(function (t) {
            return Object.assign(Object.assign({}, t), {
              hasBeenRemoved: !0
            });
          })
        });
      }, _this6.toggleRemoval = function (t, i) {
        _this6.setState(function (_ref14) {
          var i = _ref14.notifications;
          return {
            notifications: i.filter(function (_ref15) {
              var i = _ref15.id;
              return i !== t;
            })
          };
        }, i);
      }, _this6.state = {
        isMobile: f(t.isMobile) ? s : t.isMobile,
        breakpoint: f(t.breakpoint) ? a : t.breakpoint,
        notifications: [],
        windowWidth: void 0
      };
      return _this6;
    }

    _createClass(S, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props3 = this.props,
            t = _this$props3.types,
            i = _this$props3.defaultNotificationWidth;
        m.register({
          addNotification: this.add,
          removeNotification: this.remove,
          removeAllNotifications: this.removeAllNotifications,
          defaultNotificationWidth: i || r,
          types: t
        }), this.setState({
          windowWidth: window.innerWidth
        }), window.addEventListener("resize", this.handleResize);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
      }
    }, {
      key: "renderNotifications",
      value: function renderNotifications(t, i) {
        var _this7 = this;

        return t.map(function (e) {
          return o.a.createElement(b, {
            id: e.id,
            key: e.id,
            isMobile: i,
            defaultNotificationWidth: _this7.props.defaultNotificationWidth,
            notification: e,
            toggleRemoval: _this7.toggleRemoval,
            notificationsCount: t.length,
            hasBeenRemoved: e.hasBeenRemoved
          });
        });
      }
    }, {
      key: "renderMobileNotifications",
      value: function renderMobileNotifications(t) {
        var i = t.className,
            e = t.id,
            n = this.state.notifications,
            s = function (t) {
          var i = [],
              e = [];
          return t.forEach(function (t) {
            var n = t.container,
                _l = l,
                o = _l.CENTER;
            E(n) || n === o ? i.push(t) : p(n) && e.push(t);
          }), {
            top: i,
            bottom: e
          };
        }(n),
            a = this.renderNotifications(s.top, !0),
            r = this.renderNotifications(s.bottom, !0);

        return o.a.createElement("div", {
          id: e,
          key: "mobile",
          className: "notifications-component " + (i || "")
        }, o.a.createElement("div", {
          className: "notification-container--mobile-top"
        }, a), o.a.createElement("div", {
          className: "notification-container--mobile-bottom"
        }, r));
      }
    }, {
      key: "renderScreenNotifications",
      value: function renderScreenNotifications(t) {
        var i = t.className,
            e = t.id,
            n = this.state.notifications,
            s = function (t) {
          var i = [],
              e = [],
              n = [],
              o = [],
              s = [],
              a = [],
              r = [],
              c = [],
              h = [];
          return t.forEach(function (t) {
            var u = t.container;
            u === l.TOP_FULL ? c.push(t) : u === l.BOTTOM_FULL ? h.push(t) : u === l.TOP_LEFT ? i.push(t) : u === l.TOP_RIGHT ? e.push(t) : u === l.TOP_CENTER ? n.push(t) : u === l.BOTTOM_LEFT ? o.push(t) : u === l.BOTTOM_RIGHT ? s.push(t) : u === l.BOTTOM_CENTER ? a.push(t) : u === l.CENTER && r.push(t);
          }), {
            topFull: c,
            bottomFull: h,
            topLeft: i,
            topRight: e,
            topCenter: n,
            bottomLeft: o,
            bottomRight: s,
            bottomCenter: a,
            center: r
          };
        }(n),
            a = this.renderNotifications(s.topFull, !1),
            r = this.renderNotifications(s.bottomFull, !1),
            c = this.renderNotifications(s.topLeft, !1),
            h = this.renderNotifications(s.topRight, !1),
            u = this.renderNotifications(s.topCenter, !1),
            d = this.renderNotifications(s.bottomLeft, !1),
            m = this.renderNotifications(s.bottomRight, !1),
            f = this.renderNotifications(s.bottomCenter, !1),
            p = this.renderNotifications(s.center, !1);

        return o.a.createElement("div", {
          id: e,
          key: "screen",
          className: "notifications-component " + (i || "")
        }, o.a.createElement("div", {
          className: "notification-container--top-full"
        }, a), o.a.createElement("div", {
          className: "notification-container--bottom-full"
        }, r), o.a.createElement("div", {
          className: "notification-container--top-left"
        }, c), o.a.createElement("div", {
          className: "notification-container--top-right"
        }, h), o.a.createElement("div", {
          className: "notification-container--bottom-left"
        }, d), o.a.createElement("div", {
          className: "notification-container--bottom-right"
        }, m), o.a.createElement("div", {
          className: "notification-container--top-center"
        }, u), o.a.createElement("div", {
          className: "notification-container--center"
        }, o.a.createElement("div", {
          className: "flex-center"
        }, p)), o.a.createElement("div", {
          className: "notification-container--bottom-center"
        }, f));
      }
    }, {
      key: "render",
      value: function render() {
        var t = this.props.isMobile,
            _this$state2 = this.state,
            i = _this$state2.windowWidth,
            e = _this$state2.breakpoint;
        return t && i <= e ? this.renderMobileNotifications(this.props) : this.renderScreenNotifications(this.props);
      }
    }]);

    return S;
  }(o.a.Component);

  var y = S;
  i.default = y;
}]);